import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const municipalitiesFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'name',
    label: 'Название муниципалитета',
    type: TableFilterFieldType.INPUT,
  },
  {
    key: generateUUID(),
    name: 'regionId',
    label: 'Регион',
    type: TableFilterFieldType.SELECT,
    options: [],
    isLoadableOptions: true,
  },
];
